import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import { BehaviorSubject } from 'rxjs';
import { INativeAppVersionService } from '@boxx/core';
import { APP_CONSTANTS } from 'src/constants/constants';
import { App } from '@capacitor/app';

@Injectable({
  providedIn: 'root',
})
export class AppVersionService implements INativeAppVersionService {
  public whenReadySubject = new BehaviorSubject<{
    appName: string;
    packageName: string;
    versionCode: string | number;
    versionNumber: string;
  }>({
    appName: undefined,
    packageName: undefined,
    versionCode: undefined,
    versionNumber: APP_CONSTANTS.PWA_VERSION,
  });

  public whenReady$ = this.whenReadySubject.asObservable();

  private appNameVal: string;
  private packageNameVal: string;
  private versionCodeVal: string | number;
  private versionNumberVal: string = APP_CONSTANTS.PWA_VERSION;

  constructor(private platform: Platform) {
    this.platform.ready().then(async () => {
      if (this.platform.is('cordova') || this.platform.is('capacitor')) {
        const _appData = await App.getInfo();
        this.appNameVal = _appData.name;
        this.packageNameVal = _appData.id;
        this.versionCodeVal = _appData.build;
        this.versionNumberVal = _appData.version;
      }

      this.whenReadySubject.next({
        appName: this.appNameVal,
        packageName: this.packageNameVal,
        versionCode: this.versionCodeVal,
        versionNumber: this.versionNumberVal,
      });
    });
  }

  appName() {
    return this.appNameVal;
  }

  packageName() {
    return this.packageNameVal;
  }

  versionCode() {
    return this.versionCodeVal;
  }

  versionNumber() {
    return this.versionNumberVal;
  }
}
